/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';

// "COF / Credit Note" grid column - TRANSPORTER only (see epodScreen.js column def). Only ever
// rendered for a row where epod_document_type is 'cof' or 'credit_note' (the AL-approval gate
// that already exists - alReviewService.generateDocument's two branches), so this column never
// appears before the required AL/Admin approval has actually happened. Uploads reuse the
// EXISTING /billing/alReviewDocumentSignedUpload endpoint (Action 19) - the same one
// alReviewScreen.js's "Upload Signed Doc" button already calls, for either document type; the
// backend re-validates authorization/window/file independently, this is UI convenience only.

// Upload-button styling only. No existing app-wide button style matches this spec (checked
// bootstrap.css's own .btn-primary - #007bff/#0069d9 hover - and the app's custom encss.css/
// style.css overrides - neither defines #1976D2 anywhere), so this is defined locally rather than
// reusing/duplicating a same-named-but-different-colored class. Hover is handled via local
// component state (no :hover pseudo-class available on an inline style) so this stays fully
// self-contained to this one button - no new global CSS, no risk to any other button in the app.
const UPLOAD_BLUE = '#1976D2';
const UPLOAD_BLUE_HOVER = '#1565C0';
function uploadButtonStyle(hovered) {
    return {
        padding: '2px 10px', fontSize: '12px', margin: 0,
        backgroundColor: hovered ? UPLOAD_BLUE_HOVER : UPLOAD_BLUE,
        borderColor: hovered ? UPLOAD_BLUE_HOVER : UPLOAD_BLUE,
        color: '#FFFFFF', borderRadius: '6px', fontWeight: 500,
    };
}

const CofUploadButton = (props) => {
    const [uploadHovered, setUploadHovered] = useState(false);
    const parent = props.context && props.context.componentParent;
    if (!parent) return null;

    // Label only - onClickUploadCofNote/onClickViewCofNote (epodScreen.js) are already fully
    // generic and pass the whole row through unchanged regardless of document type.
    var label = props.data.epod_document_type === 'credit_note' ? 'Credit Note' : 'COF Note';

    if (props.data.epod_signed_document_status === 'signed_uploaded') {
        return (
            <button className="btn btn-outline-success" style={{ padding: '2px 10px', fontSize: '12px', margin: 0 }}
                onClick={(e) => { e.stopPropagation(); parent.onClickViewCofNote(props.data); }}>
                View {label}
            </button>
        );
    }

    return (
        <button className="btn" style={uploadButtonStyle(uploadHovered)}
            onMouseEnter={() => setUploadHovered(true)} onMouseLeave={() => setUploadHovered(false)}
            onClick={(e) => { e.stopPropagation(); parent.onClickUploadCofNote(props.data); }}>
            Upload {label}
        </button>
    );
};

export default CofUploadButton;
